import { useState } from 'react';

export default () => {
    const [visible, setVisible] = useState(false);
    const showModal = () => {
        setVisible(true);
    };

    const onCancel = () => {
        setVisible(false);
    };

    const onOk = () => {
        setVisible(false);
    };
    return {
        visible,
        showModal,
        onCancel,
        onOk,
    };
};
